import { mlogins } from '@/api/index'

const state = {
  token: localStorage.getItem('userToken') || '',
  userId: ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    localStorage.setItem('userToken', token)
  },
  SET_USER_ID: (state, userId) => {
    state.userId = userId
  },
  CLEAR_USER: (state) => {
    state.token = ''
    state.userId = ''
    localStorage.removeItem('userToken')
  }
}

const actions = {
  Login({ commit }, userId) {
    return new Promise((resolve, reject) => {
      mlogins({ userId }).then(res => {
        const data = res.data || res
        if (data.code == '200' || data.code === 200) {
          commit('SET_TOKEN', data.token)
          localStorage.setItem('ssoToken', data.ssoToken)
          commit('SET_USER_ID', userId)
          // alert('登录成功')
          resolve(data)
        } else {
          // alert('登录失败')
          reject(new Error(data.message || '登录失败'))
        }
      }).catch(error => {
        // alert('登录失败')
        reject(error)
      })
    })
  },

  Logout({ commit }) {
    commit('CLEAR_USER')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}